import React, { Children } from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import { RiskIcon } from 'assets/svgComponent'
function IconDiv(props) {
    return (
        <div className={(props?.type) == "primary" ? styles.iconp : (props?.type) == "error" ? styles.icone : (props?.type) == "success" ? styles.icons : styles.iconw}>
            <div className={(props?.type) == "primary" ? styles.iconp__icon : (props?.type) == "error" ? styles.icone__icon : (props?.type) == "success" ? styles.icons__icon : styles.iconw__icon}>
                {props.children}

            </div>
        </div>
    )
}

IconDiv.propTypes = {
    type: PropTypes.oneOf(['success', 'error', "warning", "primary"]).isRequired,
    children: PropTypes.node.isRequired
}

export default IconDiv

